import React, { useState } from 'react'
import { PropTypes } from 'prop-types'
import './ListInfo.scss'
import Button from '@material-ui/core/Button'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormControl from '@material-ui/core/FormControl'
import FormLabel from '@material-ui/core/FormLabel'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'

const ListInfo = props => {
  const [projectType, setProjectType] = useState('')
  const [confirmBtn, setConfirmBtn] = useState(true)

  const { listInfo } = props
  const { name: listName, compsList } = listInfo

  const sortedlistInfo = compsList.sort(
    (listItem1, listItem2) => listItem1.rank - listItem2.rank
  )
  const subjectPropetyList = sortedlistInfo.filter(
    listItem => listItem?.isSubjectProperty
  )

  let comparablePropetyList = []
  let list = []
  let comparableLabelCount = 0

  if (subjectPropetyList.length < 5) {
    comparablePropetyList = sortedlistInfo.filter(
      listItem => !listItem?.isSubjectProperty
    )
    list = [
      ...subjectPropetyList,
      ...comparablePropetyList.slice(0, 5 - subjectPropetyList.length)
    ]
  } else {
    list = subjectPropetyList.slice(0, 5)
  }

  const handleProjectTypeSelection = event => {
    setProjectType(event.target.value)
    if (event.target.value && compsList?.length > 0) {
      setConfirmBtn(false)
    } else {
      setConfirmBtn(true)
    }
  }

  const subjectPropertyExists = <div className="list-info-container" data-testid="list-info">
      <div className="header">
        <span className="font-style bold">{listName}</span>
        <IconButton aria-label="close" className="dialogue-close" onClick={props.close}>
          <CloseIcon />
        </IconButton>
      </div>
      {list[0]?.isSubjectProperty ? <>
          <div className="properties-container">
            <div className="subject-box">
              {Object.keys(list[0]?.data).length && <div className={`label subject ${(list[0]?.data?.omniviewproperty?.length && list[0]?.data?.omniviewproperty[0]?.unitsOrBeds) ? '' : 'no-units'}`}>
                  <span>{list[1]?.isSubjectProperty ? 'S1' : 'S'}</span>
                </div>}
              <div>
                <div className="font-style">
                  <span className="label-space">Property: </span>
                  <span className="bold">
                    {list[0]?.data?.omniviewproperty?.length
                      ? list[0]?.data?.omniviewproperty[0]?.propertyName
                      : ''}
                  </span>
                </div>
                <div className="font-style">
                  <span className="label-space">Address:</span>
                  <span className="bold">
                    {Object.keys(list[0]?.data).length &&
                    list[0]?.data?.omniviewproperty?.length
                      ? `${
                          list[0]?.data?.omniviewproperty[0]?.addressLine1
                        },${list[0]?.data?.omniviewproperty[0]?.city},${
                          list[0]?.data?.omniviewproperty[0]?.state
                        }`
                      : ''}
                  </span>
                </div>
                <div className="subject-info font-style">
                  {Object.keys(list[0]?.data).length &&
                  list[0]?.data?.omniviewproperty?.length
                  ? (list[0]?.data?.omniviewproperty[0]?.unitsOrBeds ?
                  <>
                    <span className="label-space">Units:</span>
                    <span className="bold">
                      {`${list[0]?.data?.omniviewproperty[0]?.unitsOrBeds} Units`}
                    </span>
                  </> : null)
                    : ''}
                </div>
              </div>
            </div>
            <div className="comparables">
              {list.slice(1, list.length).map((property, index) => {
                const nextIndex = list[index + 1]?.isSubjectProperty ? index : comparableLabelCount + 1
                const nextSubjectCheckIndex = index + 1
                if (!list[index + 1]?.isSubjectProperty) {
                  comparableLabelCount += 1
                }

                return <div key={`comparable-box-${nextIndex}`} className="comparable-box">
                    {Object.keys(list[nextSubjectCheckIndex]?.data).length > 0 && <div className={`label ${list[nextSubjectCheckIndex]?.isSubjectProperty ? 'subject extras' : ''}`}>
                        <span>
                          {list[nextSubjectCheckIndex]?.isSubjectProperty
                            ? `S${nextSubjectCheckIndex + 1}`
                            : nextIndex}
                        </span>
                      </div>}
                    <div className="font-style comparable">
                      {property?.data?.omniviewproperty?.length
                        ? property?.data?.omniviewproperty[0]?.propertyName
                        : ''}
                    </div>
                  </div>
              })}
            </div>
          </div>
          {compsList.length >= 5 ? (
            <div className="message">Displaying 5 out of {compsList.length} properties</div>
          ) : null
          }
          <div className="project">
            <FormControl component="fieldset">
              <FormLabel component="legend">
                <span className="project-type font-style bold">
                  Select Project Type
                </span>
              </FormLabel>
              <RadioGroup row aria-label="projectType" name="radio-buttons-group" value={projectType} onChange={handleProjectTypeSelection}>
                <FormControlLabel value="T1" control={<Radio />} label="Rent Comps" className="font-style" />
                <FormControlLabel value="S1" control={<Radio />} label="Sales Comps" className="font-style" />
                <FormControlLabel value="SH1" control={<Radio />} label="Student Housing" className="font-style" />
              </RadioGroup>
            </FormControl>
          </div>
        </> : <>
          {' '}
          <div className="comparables no-subject">
            {list.slice(0, list.length).map((property, index) => {
              const nextIndex = index + 1

              return <div key={nextIndex} className="comparable-box">
                  {Object.keys(property?.data).length > 0 && <div className="label">
                      <span>{nextIndex}</span>
                    </div>}
                  <div className="font-style comparable">
                    {Object.keys(property?.data).length > 0 &&
                      property?.data?.omniviewproperty?.length &&
                      property?.data?.omniviewproperty[0]?.propertyName}
                  </div>
                </div>
            })}
        </div>
        {compsList.length >= 5 ? (
          <div className="message">Displaying 5 out of {compsList.length} properties</div>
        ) : null
        }
          <div className="project">
            <FormControl component="fieldset">
              <FormLabel component="legend">
                <span className="project-type font-style bold">
                  Select Project Type
                </span>
              </FormLabel>
              <RadioGroup row aria-label="projectType" name="radio-buttons-group" value={projectType} onChange={handleProjectTypeSelection}>
                <FormControlLabel value="T1" control={<Radio />} label="Rent Comps" />
                <FormControlLabel value="S1" control={<Radio />} label="Sales Comps" />
                <FormControlLabel value="SH1" control={<Radio />} label="Student Housing" />
              </RadioGroup>
            </FormControl>
          </div>
        </>}
      <div className="actions">
        <Button className="action-btn" color="primary" variant="contained" size="large" onClick={props.listConfirmationCancelled}>
          Cancel
        </Button>
        <Button className="action-btn" color="primary" variant="contained" size="large" onClick={() => props.confirmListHandler({ projectType, listName })} disabled={confirmBtn}>
          Confirm
        </Button>
      </div>
    </div>

  return <>{subjectPropertyExists}</>
}

ListInfo.propTypes = {
  listInfo: PropTypes.object,
  listConfirmationCancelled: PropTypes.func,
  confirmListHandler: PropTypes.func,
  close: PropTypes.func
}

export default ListInfo
